const Menu=[
    {
        id:1,
        images:"images/vgn_fairmont_1.jpg",
        category:"Chennai",
        type:"VGN FAIRMOUNT",
        bed:"BHK: 2 & 3",
        Place:"GUNIDY, Chennai"
    },
    {
        id:2,
        images:"images/eterna11.jpg",
        category:"Chennai",
        type:"ETERNA",
        bed:"BHK: 2 & 3",
        Place:"KARAPAKKAM, Chennai"
    },
    {
        id:3,
        images:"images/Impressions_optimized.jpg",
        category:"Chennai",
        type:"KG Impression",
        bed:"BHK: 2 & 3",
        Place:"Thoraipakkam, Chennai"
    },
    {
        id:4,
        images:"images/doshi3.jpg",
        category:"Chennai",
        type:"Doshi - Risington",
        bed:"BHK: 2 & 3",
        Place:"Karapakkam, Chennai"
    },
    {
        id:5,
        images:"images/tudor0.jpg",
        category:"Chennai",
        type:"Casagrand - Tudor",
        bed:"BHK: 2 & 4",
        Place:"Mogappair, Chennai"
    },
    {
        id:6,
        images:"images/crescendo.jpg",
        category:"Chennai",
        type:"Caresendo",
        bed:"BHK: 2 & 3",
        Place:"Chennai"
    },
    {
        id:7,
        images:"images/athens2.jpg",
        category:"Chennai",
        type:"Casagrand - Athens",
        bed:"BHK: 1 & 2",
        Place:"Ambattur, Chennai"
    },
    {
        id:8,
        images:"images/Casagrand_Flagship_1.jpg",
        category:"Chennai",
        type:"Casagrand - Flagship",
        bed:"BHK: 1 & 2",
        Place:"Pallikaranai, Chennai"
    },
    {
        id:9,
        images:"images/Alliance.jpeg",
        category:"Chennai",
        type:"Alliance - New Porur",
        bed:"BHK: 2 & 3",
        Place:"Thirumazhisai, Chennai"
    },
    // {
    //     id:10,
    //     images:"images/s11.jpg",
    //     category:"Bangalore",
    //     type:"Radiance The Pride",
    //     bed:"BHK: 2 & 3",
    //     Place:"Thambaram"
    // },
    {
        id:10,
        images:"images/Ashraya.jpeg",
        category:"Chennai",
        type:"Altis - Ashraya",
        bed:"BHK: 2 & 3",
        Place:"Maangadu, Chennai"
    },
    {
        id:11,
        images:"images/s12.jpg",
        category:"Andhra",
        type:"Radiance The Pride",
        bed:"BHK: 2 & 3",
        Place:"Guindy"
    },
    {
        id:12,
        images:"images/tudor0.jpg",
        category:"Bangalore",
        type:"Radiance The Pride",
        bed:"BHK: 2 & 3",
        Place:"Maangadu"
    },


]
    
export default Menu;